import { createContext, useContext } from "react";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { CompanySidebar } from "@/components/CompanySidebar";
import { MobileHeader } from "@/components/MobileHeader";

const SidebarLayoutContext = createContext(false);

export function useSidebarLayoutContext() {
  return useContext(SidebarLayoutContext);
}

interface CompanyLayoutProps {
  children: React.ReactNode;
  activeRoute?: string;
}

export function CompanyLayout({ children, activeRoute }: CompanyLayoutProps) {
  const isInsideLayout = useSidebarLayoutContext();
  
  if (isInsideLayout) {
    return <>{children}</>;
  }
  
  return (
    <SidebarLayoutContext.Provider value={true}>
      <SidebarProvider defaultOpen={true}>
        <CompanySidebar activeRoute={activeRoute} />
        <SidebarInset className="bg-background min-h-screen overflow-x-hidden">
          <MobileHeader />
          {children}
        </SidebarInset>
      </SidebarProvider>
    </SidebarLayoutContext.Provider>
  );
}
